import React, { useState, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row'
import { Trash } from "react-bootstrap-icons";
import { Plus } from "react-bootstrap-icons";
import { PencilSquare } from "react-bootstrap-icons";
import { Check } from "react-bootstrap-icons";

///////////////////////////////////////////////////////////
///////// Test component with PUT - ATTENTION: Date format DateTimeOffset:  "date": "2022-11-14T13:38:15.487+00:00"
/////////////////////////////////////////////////


const TESTEdit = () => {

  const formRef = useRef(null);
  const [datum, setdatum] = useState("");
  const [formvalues, setValues] = useState({});
  const [updatevalues, setupdatevalues] = useState({});
  const [validated, setValidated] = useState(false);
  const [data, setdata] = useState([]);
  const [editindex, seteditindex] = useState(null);

  const onFormChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setValues({ ...formvalues, [name]: value });
    let g = formvalues
    console.log(formvalues)
  };

  const onFormUpdate = (e) => {
    debugger
    const name = e.target.name;
    const value = e.target.value;
    setupdatevalues({ ...updatevalues, [name]: value });
  };

  const onDateChange = (e) => {
    const value = e.target.value;
    setdatum({ value });
  };

  const handleSubmit = (event) => {
    debugger
    let z = formvalues
    let d = updatevalues
    let req = {
      data: [formvalues],
      date:"2022-11-14T13:38:15.487Z",
      type: 'new'
    }

   updateScreenData(req)

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
    event.preventDefault();
    event.persist();

    
    let newdata = [];

    if (Object.keys(formvalues).length >= 6) {
      if (data.length === 0) {
        newdata.push(formvalues)
        setdata(newdata)
        handleReset()
      } else {
        newdata = data
        newdata.push(formvalues)
        setdata(newdata)
        handleReset()
      }
    }
    setValues({})
  };

  const handleReset = () => {
    formRef.current.reset();
    setValidated(false);
  };

  const handleRemoveWithIndex = (index) => {
    let newdata = [...data]
    newdata.splice(index, 1)
    setdata(newdata)
    handleReset()
  };

  const handleEditRow = (index) => {
    console.log(data.at(index))
    seteditindex(index)
    setupdatevalues(data.at(index))
  }

  const handleUpdate = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Hit Update")

    console.log(updatevalues)
    console.log(editindex)

    let updatedata = [...data]
    updatedata[editindex] = updatevalues
    console.log(updatedata)
    setdata(updatedata)
    seteditindex(null)
  }
  console.log(updatevalues)

 async function updateScreenData(data) {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
  };
  fetch('/screendata', requestOptions)
      ///.then(response => response.json())
      .then(res =>  console.log("DATA:_ ", res) );
  }

  return (
    <Container fluid>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} md="2" controlId="validationCustom01">
            <Form.Control
              required
              type="text"
              placeholder="Datum"
              name="date"
              defaultValue=""
              onChange={onDateChange}
            />
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} md="2" controlId="validationCustom03">
            <Form.Control
              type="text"
              placeholder="Frächter"
              required
              name="freighter"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="2" controlId="validationCustom04">
            <Form.Control
              type="text"
              placeholder="Referenz"
              required
              name="reference"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="1" controlId="validationCustom05">
            <Form.Control
              type="text"
              placeholder="Kommission"
              required
              name="commission"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="2" controlId="validationCustom06">
            <Form.Control
              type="text"
              placeholder="Lagerort"
              required
              name="stockplace"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="1" controlId="validationCustom07">
            <Form.Control
              type="text"
              placeholder="Pal. Anzahl"
              required
              name="quantity"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="2" controlId="validationCustom08">
            <Form.Control
              type="text"
              placeholder="Kennzeichen"
              required
              name="licenseplate"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="1" controlId="validationCustom08">
            <Form.Control
              type="text"
              placeholder="Ladereihenfolge"
              required
              name="loadingorder"
              onChange={onFormChange}
            />
          </Form.Group>
          <Form.Group as={Col} md="1" controlId="validationCustom08">
            <Button type="submit"><Plus /></Button>
          </Form.Group>
        </Row>


      </Form>

      {data.lenght !== 0 &&
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Frächter</th>
              <th>Referenz</th>
              <th>Kommission</th>
              <th>Lagerort</th>
              <th>Pal. Anzahl</th>
              <th>Kennzeichen</th>
              <th>Ladereihenfolge</th>
              <th></th>
            </tr>
          </thead>
          <tbody>

            {(data || []).map(function (item, index) {

              if (editindex === index) {
                return (
                  <tr key={index}>
                    <td colSpan="8">
                      <Form ref={formRef} noValidate validated={validated} onSubmit={handleUpdate}>
                        <Row className="mb-3">
                          <Form.Group as={Col} md="2" controlId="validationCustom03">
                            <Form.Control
                              type="text"
                              placeholder="Frächter"
                              required
                              name="fraechter"
                              value={updatevalues.fraechter}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="2" controlId="validationCustom04">
                            <Form.Control
                              type="text"
                              placeholder="Referenz"
                              required
                              name="referenz"
                              value={updatevalues.referenz}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="1" controlId="validationCustom05">
                            <Form.Control
                              type="text"
                              placeholder="Kommission"
                              required
                              name="kommission"
                              value={updatevalues.kommission}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="2" controlId="validationCustom06">
                            <Form.Control
                              type="text"
                              placeholder="Lagerort"
                              required
                              name="lagerort"
                              value={updatevalues.lagerort}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="1" controlId="validationCustom07">
                            <Form.Control
                              type="text"
                              placeholder="Pal. Anzahl"
                              required
                              name="palanzahl"
                              value={updatevalues.palanzahl}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="2" controlId="validationCustom08">
                            <Form.Control
                              type="text"
                              placeholder="Kennzeichen"
                              required
                              name="kennzeichen"
                              value={updatevalues.kennzeichen}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="1" controlId="validationCustom08">
                            <Form.Control
                              type="text"
                              placeholder="Ladereihenfolge"
                              required
                              name="ladereihenfolge"
                              value={updatevalues.ladereihenfolge}
                              onChange={onFormUpdate}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md="1" controlId="validationCustom08">
                            <Button type="submit"><Check /></Button>
                          </Form.Group>
                        </Row>
                     </Form>
                    </td>
                  </tr>
                )
              }

              return (
                <tr key={index}>
                  <td>{item.fraechter}</td>
                  <td>{item.referenz}</td>
                  <td>{item.kommission}</td>
                  <td>{item.lagerort}</td>
                  <td>{item.palanzahl}</td>
                  <td>{item.kennzeichen}</td>
                  <td>{item.ladereihenfolge}</td>
                  <td>
                    <Trash onClick={() => handleRemoveWithIndex(index)} />
                    <PencilSquare onClick={() => handleEditRow(index)} />
                  </td>
                </tr>
              )
            }, editindex)}
          </tbody>
        </Table>
      }
    </Container>
  );
}

export default TESTEdit;
